import { AdditionalInfo as OrdersAdditionalInfo } from '@modules/Orders/ViewOrders/components/display/AdditionalInfo';
import { FC } from 'react';
import type { OrderLine } from '@modules/Orders/ViewOrders/models/Order';

interface AdditionalInfoProps {
  paymentMethodId?: number;
  orderId?: number;
  lines?: OrderLine[];
  statusId?: number;
  onUpdate?: () => void;
}

export const AdditionalInfo: FC<AdditionalInfoProps> = (props) => {
  return <OrdersAdditionalInfo {...props} />;
};
